export const buttonTheme = {
  MuiButton: {
    variants: [
      {
        props: { variant: "contained" },
        style: ({ theme }) => ({
          boxShadow:
              "0px 2px 4px -2px rgba(22, 34, 51, 0.4), 0px 8px 16px rgba(22, 34, 51, 0.4)",
          "&:hover": {
            boxShadow:
              "0px 4px 8px -4px rgba(22, 34, 51, 0.08), 0px 16px 24px rgba(22, 34, 51, 0.08)",
          },
        }),
      },
      {
        props: { variant: "FAB" },
        style: ({ theme }) => ({
          borderRadius: 50,
          backgroundColor: theme.palette.common.white,
          color: theme.palette.primary.main,
          border: `1px solid ${theme.palette.primary.main}`,
          "&:hover": {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.common.white,
          },
        }),
      },
      {
        props: { variant: "custom-outlined" },
        style: ({ theme }) => ({
          color: theme.palette.common.black,
          border: `2px solid ${theme.palette.common.white}`,
          "&:hover": {
            border: `2px solid ${theme.palette.common.white}`,
            backgroundColor: theme.palette.primary.dark,
            boxShadow:
              "0px 4px 8px -4px rgba(22, 34, 51, 0.08), 0px 16px 24px rgba(22, 34, 51, 0.08)",
          },
        }),
      },
    ],
    styleOverrides: {
      // Name of the slot
      root: {
        // Some CSS
        padding: "10px 24px",
        // borderRadius: "12px",
        borderRadius: "50px",
      },
      // sizeLarge: {
      //   padding: "14px 28px",
      // },
      // sizeSmall: {
      //   padding: "4px 10px",
      //   fontSize: "14px",
      //   minWidth: "unset",
      // },
    },
  },
};
